import { __awaiter } from "tslib";
import { notes } from "@phoenixreisen/mithrils/src/notification";
import { getCustomer } from "../../../../shared/functions/fns.travel";
import { authCustomer } from "../../../../shared/functions/fns.auth";
import { fields, isValidForm } from "./form.model.fields";
import Model from "../../model";
import m from "mithril";
function submit(showAddressForm, state, e) {
    return __awaiter(this, void 0, void 0, function* () {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        const { customer } = fields;
        if (isValidForm(customer)) {
            showAddressForm(false);
            try {
                state.loading = true;
                const auth = yield authCustomer(customer.number.value(), customer.zip.value());
                const data = yield getCustomer(customer.number.value(), auth.jwt);
                Model.prefillAddressFormWith(data);
                showAddressForm(true);
            }
            catch (e) {
                notes.add({
                    status: "error",
                    text: `Zu diesen Angaben konnten wir
                leider keine Kundendaten finden.`,
                });
                console.error(JSON.stringify(e));
            }
            finally {
                state.loading = false;
                m.redraw();
            }
        }
    });
}
export default {
    oninit({ state }) {
        state.loading = false;
    },
    view({ attrs, state }) {
        const { customer } = fields;
        const { showForm, showAddressForm } = attrs;
        return (m("form", { class: `form ${showForm() ? "fade-in" : "fade-out"}`, onsubmit: (e) => submit(showAddressForm, state, e) },
            m("div", { class: "row row--2er" },
                m("label", { class: "textfield" },
                    m("input", { name: "customer", autocomplete: "customer", type: "text", maxLength: "20", value: customer.number.value(), oninput: (e) => customer.number.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${customer.number.complaint ? "alert--warning" : ""}` }, "Kundennummer*")),
                m("label", { class: "textfield" },
                    m("input", { autocomplete: "zipcode", name: "zipcode", type: "text", maxLength: "20", value: customer.zip.value(), oninput: (e) => customer.zip.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${customer.zip.complaint ? "alert--warning" : ""}` }, "Postleitzahl*"))),
            !state.loading && !showAddressForm() ? (m("div", { class: "tr" },
                m("button", { type: "submit" }, "Daten abfragen"))) : (""),
            m("div", { class: `mb2 mt3 ${state.loading ? "fade-in" : "fade-out"}` },
                m("div", { class: "tc" },
                    m("i", { class: "fas fa-spinner fa-spin" })),
                m("div", { class: "tc" }, "Daten werden geladen..."))));
    },
};
